import { render, staticRenderFns } from "./informationDetails.vue?vue&type=template&id=2ff20bb3&"
import script from "./informationDetails.vue?vue&type=script&lang=js&"
export * from "./informationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports